// getRandomValues, not randomUUID: randomUUID exists only in a secure context, so it is
// missing whenever ops is opened over http on anything but localhost.
export const randomHex = (byteCount: number): string =>
  Array.from(crypto.getRandomValues(new Uint8Array(byteCount)), (byte) => byte.toString(16).padStart(2, '0')).join(
    ''
  )
